import { render, staticRenderFns } from "./CleanupConfirmDialogBox.vue?vue&type=template&id=19243e60&scoped=true&"
import script from "./CleanupConfirmDialogBox.vue?vue&type=script&lang=js&"
export * from "./CleanupConfirmDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19243e60",
  null
  
)

export default component.exports